<template>
  <transition name="el-zoom-in-center">
    <el-card v-show="update.show" class="box-card" style="text-align: left;">
      <div slot="header" class="clearfix">
        <el-row>
          <el-col :span="12">
            <h3>修改</h3>
          </el-col>
          <el-col :span="12">
            <el-button style="float: right;" type="primary" @click="update.show=false">收起</el-button>
          </el-col>
        </el-row>
      </div>
      <el-form ref="update.form" :model="update.form" label-width="110px" :rules="rules">
        <el-row>
          <el-col :span="18" :offset="6">
            <el-form-item label="标题" prop="column_title">
              <el-input v-model.trim="update.form.column_title" style="width:200px" />
            </el-form-item>
            <el-form-item label="说明">
              <Single-Image ref="mychild" :uploadimg="uploadimg" />
            </el-form-item>
            <el-form-item label="启用/禁用" prop="status">
              <el-switch
                v-model="update.form.status"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="0"
                :inactive-value="1"
              ></el-switch>
            </el-form-item>
            <el-form-item label="排序" prop="sort">
              <template>
                <el-input-number
                  v-model="update.form.sort"
                  controls-position="right"
                  :min="0"
                  :max="1000"
                ></el-input-number>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div>
        <br />
        <div style="text-align: center;">
          <el-button style="margin-top: 12px;" @click="resetForm('update.form')">重置</el-button>
          <el-button style="margin-top: 12px;" type="primary" @click="submitadd('update.form')">提交</el-button>
        </div>
      </div>
    </el-card>
  </transition>
</template>

<script>
import PanThumb from "@/components/PanThumb";
import { productlist, productextendedit } from "@/api/base";
import { departtree, findByParentCode } from "@/api/orgin";
import { findwarehouse, updatewarehouse } from "@/api/query";
import SingleImage from "@/components/Upload/SingleImage";
import { getToken } from "@/utils/auth";
import { downloadimg } from "@/api/plant";
export default {
  components: { SingleImage, PanThumb },
  props: {
    search: {
      type: Function,
      default: null,
    },
    update: {
      type: Object,
      default: () => {
        return {
          show: false,
          form: {
            id: null,
            product_code: null,
            column_title: null,
            column_value: null,
            status: null,
            sort: null,
          },
        };
      },
    },
  },
  data() {
    return {
      uploadimg: {
        uploadurl:
          process.env.VUE_APP_BASE_API + "/api/produce/fileuploader/uploadimg",
        resimg: '',
        uploaddata: { folder: "xyq" },
        headers: { Token: getToken() },
        fileList: [],
      },
      // 基础数据
      show: true,
      departtree: null, // 掉接口返回部门树
      elselectProps: {
        children: "listSubWareHouses",
        label: "depart_name",
        value: "depart_code",
        id: "depart_uuid",
        checkStrictly: true,
      },
      province: [],
      city: [],
      district: [],
      fromWarehouse: [],
      rules: {
        column_title: [
          { required: true, message: "请输入标题", trigger: "blur" },
        ],
        column_value: [
          { required: true, message: "请输入说明", trigger: "blur" },
        ],
        sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
      },
    };
  },
  mounted() {},
  methods: {
    // 获取图片
    getimg(img) {
      this.uploadimg.fileList = [];
      downloadimg({
        filename: img,
        appkey: "",
        sign: "",
      }).then((res) => {
        // 有图片这添加到列表
        this.uploadimg.fileList.push({
          name: "yage",
          url: "data:image/png;base64," + res.data,
        });
      });
    },
    // 保存提交
    submitadd(formName) {
      this.$refs[formName].validate((valid) => {
        // 基础表单验证
        if (valid) {
          this.update.form.column_value = this.uploadimg.resimg ? this.uploadimg.resimg :this.update.form.column_value;
          productextendedit(this.update.form).then((response) => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "修改成功!",
              });
              this.search();
              this.resetForm(formName);
              this.update.show = false;
            } else {
              this.$message({
                type: "warning",
                message: "修改失败!请检查字段",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 清空表单数据
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.update.form.cityId = "";
      this.update.form.districtId = "";
      this.$refs.mychild.$refs.upload.clearFiles();
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
